import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../service/auth-service';
import { CommonModule } from '@angular/common';
import { TextInputComponent } from '../../../shared/components/text-input/text-input.component';
import { emailValidator } from '../../../shared/validators/common.validators';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TextInputComponent, RouterLink],
})
export class ForgotPasswordComponent {
  forgotPasswordForm: FormGroup;
  isLoading = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private toastr: ToastrService
  ) {
    this.forgotPasswordForm = this.fb.group({
        email: new FormControl('', emailValidator),
    });
  }

  onSubmit() {
    if (this.forgotPasswordForm.invalid) {
      return;
    }

    this.isLoading = true;
    const { email } = this.forgotPasswordForm.value;

    this.authService.forgotPassword(email).pipe(
      finalize(() => {
        this.isLoading = false;
      })
    ).subscribe({
      next: () => {
        this.toastr.success('Password reset link has been sent to your email');
        this.router.navigate(['/auth/login']);
      },
      error: (error) => {
        this.toastr.error(error.error?.message || 'Failed to send reset link');
      }
    });
  }

  getControl(fieldName: string): FormControl {
    return (this.forgotPasswordForm.get(fieldName) as FormControl) || new FormControl();
  }


  private markFormGroupTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((key) => {
      const control = formGroup.get(key);
      if (control instanceof FormControl) {
        control.markAsTouched();
        control.markAsDirty();
      }
    });
  }
  
}
